export const DEVENIR_COURSIER = 'devenir-coursier';


// WEBPACK FOOTER //
// ./src/constants/contractsData.js